// export const BACKURL = 'https://crm-dev-api.pupaproj.ru'
// 

export const BACKURL = 'https://api.bobcrm.ru'